export const figure11 = {

chart: {
  zoomType: 'xy',
  animation: false,
  marginTop: 50,
  marginLeft: 100,
  marginBottom: 175,
  plotBackgroundColor: null,
  plotBorderWidth: null,
  plotShadow: false,
  type: 'column',
  height: '400px',
  backgroundColor: 'rgba(255, 255, 255, 0.0)',
  style: {
    fontFamily: 'Montserrat'
  }
},

title: {
    text: null
},
subtitle: {
    text: null
},
credits: {
  enabled: false
},
legend: {
  enabled: false,
},

  
exporting: {
  enabled: false
},
colors: ['#ed7d31', '#5b9bd5'],
xAxis: {
    categories: [
        "Burkina Faso 2014",
        "Etiopía 2014",
        "Etiopía 2016",
        "India 2005",
        "India 2012",
        "Malawi 2011",
        "Malawi 2013",
        "Malawi 2017",
        "Malí 2014",
        "Malí 2017",
        "Níger 2011",
        "Níger 2014",
        "Nigeria 2013",
        "Nigeria 2016",
        "Nigeria 2019",
        "República Unida de Tanzanía 2009",
        "República Unida de Tanzanía 2011",
        "República Unida de Tanzanía 2013",
        "Uganda 2010",
        "Uganda 2011",
        "Uganda 2012",
        "Uganda 2014",
        "Uganda 2016"
],
    crosshair: true
},
yAxis: {
    min: 0,
    max: 30,
    tickInterval: 5,
    title: {
        text: null
    }
},
tooltip: {
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b> {point.y:.1f} mm</b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true
},
plotOptions: {
    column: {
        pointPadding: 0.2,
        borderWidth: 0
    }
},
series: [
{
    name: 'Otros productoress',
    data: [
      5.994973092,
      6.896319482,
      6.447007874,
      18.89980833,
      18.08269643,
      8.51559053,
      9.588852573,
      5.136225588,
      7.449663536,
      21.84924694,
      9.51021365,
      7.935464226,
      28.09619496,
      8.909352362,
      8.39844472,
      5.969932196,
      6.754417988,
      5.476531081,
      8.45084291,
      5.845587351,
      6.497514459,
      6.393908996,
      5.465315362
      ]

},
{
    name: 'Productores en pequeña escala',
    data: [
3.637831877,
4.187890215,
4.665550844,
5.570109535,
8.076765589,
4.898347948,
6.77430782,
5.096838976,
7.841335201,
13.50110198,
4.912213793,
5.585570605,
11.47411606,
3.923867555,
4.849760396,
3.407591389,
4.34130264,
3.554716321,
4.742354029,
3.759629124,
4.274266665,
4.055377726,
3.790183251,
    ]
}
]
}